function isEnvCaptureGoogleAnalyticsEvents(): boolean {
  // ビルドのモードがdevelopment以外の場合にGAのイベントをキャプチャする
  return import.meta.env.MODE != "development"
}

export {
  isEnvCaptureGoogleAnalyticsEvents
}
